import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'assetManagement'
const initialState = {
  list: null,
  assetLogs: null,
  assetLoading: false,
  query: {
    que: null,
    typeId: null,
    conditionId: null,
    statusId: null,
    assigneeType: null,
    inRepair: false,
  }
}


export const search = createApiAction('asset/search', client.search('/api/asset'))

export const get = createApiAction('asset/get', client.retrieve(`/api/asset/:id`))

export const save = createApiAction('asset/save', client.save('/api/asset'))

export const destroy = createApiAction('asset/delete', client.destroy('/api/asset/:id'))

export const getAssetLogs = createApiAction('asset/log', client.search('/api/asset/log/:id'))

export const transferAsset = createApiAction('asset/transferAsset', client.save('/api/asset/transfer'))

export const createDraft = createApiAction('asset/createDraft', client.create('/api/asset/draft'))

export const acceptDraft = createApiAction('asset/acceptDraft', client.update('/api/asset/draft/:id'))

const update = (state, action) => {
  const found = state.list?.find(rec => rec.id === action.payload.id)
  state.list = found
    ? state.list.map(item => (found.id === item.id ? action.payload : item))
    : [...(state.list || []), action.payload]
}

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {
    clearAssets: state => {
      state.list = null
    },
    setSearchApplicationQuery: (state, action) => {
      state.query = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(search.pending, (state) => {
        state.assetLoading = true
      })

      .addCase(search.fulfilled, (state, action) => {
        state.list = action.payload
        state.assetLoading = false
      })
      .addCase(getAssetLogs.fulfilled, (state, action) => {
        state.assetLogs = action.payload
      })

      .addCase(get.fulfilled, update)
      .addCase(save.fulfilled, update)
      .addCase(acceptDraft.fulfilled, update)
      .addCase(destroy.fulfilled, (state, action) => {
        state.list = state.list.filter(item => String(item.id) !== String(action.payload));
      });
  },
})

export const { clearAssets, setSearchApplicationQuery } = sessionSlice.actions
export default sessionSlice.reducer